var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"periodicals"},[_c('div',{staticClass:"contents"},[_c('div',{staticClass:"contents-left"},[(_vm.periodicalsObj.contentBase)?_c('div',{staticClass:"html"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.periodicalsObj.contentBase.content)}})]):_vm._e()]),_c('about')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }